import { Body1 } from '@cian/ui-kit';
import { IconProductDocumentsVerified24 } from '@cian/ui-kit-design-tokens/icons';

import styles from './DocumentProof.css';

interface IProofProps {
  text: string;
}

export function DocumentProof({ text }: IProofProps) {
  return (
    <div className={styles['container']} data-name="DocumentProof">
      <IconProductDocumentsVerified24 color="icon-main-default" />
      <Body1>{text}</Body1>
    </div>
  );
}
